export default {
    name: 'Register-step2',
    props: {
        mnomenics: {
            type: Array,
            default: () => [
                ' ',
                ' ',
                ' ',
                ' ',
                ' ',
                ' ',
                ' ',
                ' ',
                ' ',
                ' ',
                ' ',
                ' ',
                ' ',
            ],
        },
    },
    data() {
        return {
            mnomenicsStatus: {
                checked: false,
            },
        };
    },
    mounted() {},
    methods: {
        to(url) {
            window.location.href = url;
        },
        completeRegister() {
            const self = this;
            if (!self.mnomenicsStatus.checked) {
                self.$Message.error(self.$t('account_please_agree_the_anouncement_below'));
            } else {
                self.$emit('goToStep3', 'success');
            }
        },
        printPage() {
            window.print();
        },
    },
};



// WEBPACK FOOTER //
// ./src/components/ruc/registerStep2.js